module.exports = __webpack_public_path__ + "static/media/mdi_format_align_left.1b6302d4.svg";